import { render, staticRenderFns } from "./ResultTip.vue?vue&type=template&id=5390e7a6&lang=html"
import script from "./ResultTip.vue?vue&type=script&lang=js"
export * from "./ResultTip.vue?vue&type=script&lang=js"
import style0 from "./ResultTip.vue?vue&type=style&index=0&id=5390e7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports